import { render, staticRenderFns } from "./CalendarShared.vue?vue&type=template&id=6804aff2"
import script from "./CalendarShared.ts?vue&type=script&lang=ts&external"
export * from "./CalendarShared.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports